import React from 'react';

import FarmProductionRecordAddForm from './FarmProductionRecordAddForm';

export default function FarmProductionRecordAddWasteScreen() {
  return (
    <FarmProductionRecordAddForm
      type="WASTE"
      title="Add Wastage Records"
      successMessage="Create Wastage Record successfully"
    />
  );
}
